import { createSelector } from 'reselect';
import type { RootState } from '@/redux/types';

const getGameIndex = createSelector(
  (state: RootState) => state.campaign,
  (campaign) => campaign.gameIndex ?? 0
);

export const getCampaignId = createSelector(
  (state: RootState) => state.campaign,
  (campaign) => campaign.id
);

export const getCampaignGames = createSelector(
  (state: RootState) => state.campaign,
  (campaign) => campaign.campaignGames
);

export const getCampaignGame = createSelector(
  getGameIndex,
  (state: RootState) => state.campaign,
  (gameIndex, campaign) => campaign.campaignGames?.[gameIndex]
);

export const getCampaignGameId = createSelector(
  getGameIndex,
  (state: RootState) => state.campaign,
  (gameIndex, campaign) => campaign.campaignGames?.[gameIndex].id
);

export const getCampaignTimezone = createSelector(
  (state: RootState) => state.campaign,
  (campaign) => campaign.timezone
);

export const getCampaignServerTime = createSelector(
  (state: RootState) => state.campaign,
  (campaign) => campaign.serverTime
);

export const getCampaignCurrentTime = createSelector(
  (state: RootState) => state.campaign,
  (campaign) => campaign.currentTime
);
